import styled from 'styled-components'

import { H6 } from '../style/Typography.style'

const GroupedCheckbox = ({ checkboxProps = [], title, onChange }) => {
  return (
    <>
      <H6 mb="0.5rem">{title} </H6>
      <StyledGroupedCheckboxWrapper>
        {checkboxProps.map((cb) => (
          <StyledCheckboxWrapper key={cb.id}>
            <input
              type="checkbox"
              className="check"
              checked={cb.checked}
              onChange={(e) => onChange(cb.id, e.target.checked)}
            ></input>
            <label className="label">{cb.title}</label>
          </StyledCheckboxWrapper>
        ))}
      </StyledGroupedCheckboxWrapper>
    </>
  )
}

const StyledGroupedCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const StyledCheckboxWrapper = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-right: 2.1rem;
  margin-bottom: 0px;
  -webkit-box-pack: start;
  justify-content: flex-start;
  position: static;
  inset: auto;

  .check {
    width: 1rem;
    height: 1rem;
    border: 1px solid rgb(14, 19, 36);
    accent-color: rgb(14, 19, 36);
    border-radius: 0px;
    cursor: pointer;
  }

  .label {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    font-weight: 300;
    color: rgb(14, 19, 36);
  }
`

export default GroupedCheckbox
